import { Injectable } from "@angular/core";
import { PhysicianPractice } from "../../../core/model/v2/practitioner/physicianPractice";
import { BehaviorSubject, Subject } from "rxjs";
import { GlobalHealthSystem } from "src/app/core/model/v2/healthSystem/global-health-system";
import { PhysicianHeader } from "src/app/core/model/v2/practitioner/physician-header";

@Injectable({
  providedIn: "root",
})
export class PhysicianOptionService {
  private selectedPhysician: BehaviorSubject<PhysicianPractice> =
    new BehaviorSubject(new PhysicianPractice());
  private selectedHealthSystem: BehaviorSubject<GlobalHealthSystem> =
    new BehaviorSubject(new GlobalHealthSystem());

  selectionChange$: Subject<PhysicianHeader> = new Subject<PhysicianHeader>();

  public showSelector: boolean = true;

  constructor() {}

  hasValues(): boolean {
    return (
      this.selectedPhysician.value.id !== undefined &&
      this.selectedHealthSystem.value.id !== undefined
    );
  }

  setPhysician(physician: PhysicianPractice): void {
    this.selectedPhysician.next(physician);
    const header = this.getCurrentHeader();
    this.selectionChange$.next(header);
  }

  private getCurrentHeader() {
    return new PhysicianHeader(
      this.selectedPhysician.value,
      this.selectedHealthSystem.value
    );
  }

  getPhysician(): PhysicianPractice {
    return this.selectedPhysician.value;
  }

  setHealthSystem(healthSystem: GlobalHealthSystem): void {
    this.selectedHealthSystem.next(healthSystem);
    const header = this.getCurrentHeader();
    this.selectionChange$.next(header);
  }

  getHealthSystem(): GlobalHealthSystem {
    return this.selectedHealthSystem.value;
  }

  setOptions(
    physician: PhysicianPractice,
    healthSystem: GlobalHealthSystem
  ): void {
    this.selectedPhysician.next(physician);
    this.selectedHealthSystem.next(healthSystem);
    const header = this.getCurrentHeader();
    this.selectionChange$.next(header);
  }
}
